import { QueryClient } from "@tanstack/react-query";
import { getEntitiesAccountsQueryKey } from "@queries/entitiesAccounts";

interface InvalidateCashItemQueriesParams {
    queryClient: QueryClient;
    workspaceId: string | null | undefined;
}

export async function invalidateCashItemQueries({
    queryClient,
    workspaceId,
}: InvalidateCashItemQueriesParams): Promise<void> {
    await queryClient.invalidateQueries({ queryKey: ["transactions"] });
    await queryClient.invalidateQueries({
        queryKey: ["bank-reconciliation"],
    });
    if (workspaceId) {
        await queryClient.invalidateQueries({
            queryKey: getEntitiesAccountsQueryKey(workspaceId),
        });
    }
}
